















import Vue from 'vue';
import NOC from '@/class/common/const';
import UninstallHelpList from '@/parts/app/UninstallHelpList.vue';
import TermsFooter from './TermsFooter.vue';

export default Vue.extend({
  name: 'Help',
  components: {
    TermsFooter, UninstallHelpList,
  },
});
